import { defineStore } from 'pinia';
import { external } from '../apis/external';
import { game } from '../apis/game';
import { prefix } from '../apis/prefix';

import type { ExternalPrefixResult } from '../types/external';
import type { PrefixResult } from '../types/prefix';
import type { GameStatusResult } from '../types/game';

export const useWebStore = defineStore('web', {
	state: () => ({
		webPrefix: null as ExternalPrefixResult | null,
		webPermission: null as PrefixResult | null,
		webGame: null as GameStatusResult | null,
	}),

	actions: {
		async fetchPrefix() {
			try {
				const resp = await external.prefix({ data: null });
				if (resp.code !== '0') throw new Error(resp.message);
				this.webPrefix = resp.result as ExternalPrefixResult;
				localStorage.setItem('webPrefix', JSON.stringify(this.webPrefix));
			} catch (err) {
				console.error('fetchPrefix failed:', err);
			}
		},

		async fetchPrefixPermission() {
			try {
				const resp = await prefix.permission();
				if (resp.code !== '0') throw new Error(resp.message);
				this.webPermission = resp.result as PrefixResult;
				localStorage.setItem('webPermission', JSON.stringify(this.webPermission));
			} catch (err) {
				console.error('fetchPrefixPermission failed:', err);
			}
		},

		async fetchGameStatus() {
			try {
				const resp = await game.status();
				if (resp.code !== '0') throw new Error(resp.message);
				this.webGame = resp.result as GameStatusResult;
				localStorage.setItem('webGame', JSON.stringify(this.webGame));
			} catch (err) {
				console.error('fetchGameStatus failed:', err);
			}
		},

		hydrate() {
			const prefix = localStorage.getItem('webPrefix');
			if (prefix) this.webPrefix = JSON.parse(prefix);

			const permission = localStorage.getItem('webPermission');
			if (permission) this.webPermission = JSON.parse(permission);

			const game = localStorage.getItem('webGame');
			if (game) this.webGame = JSON.parse(game);
		},
	},
});
